import { useEffect, useRef, useState } from "react";
import MenuLayout from "../../layouts/MenuLayout";
import { useNavigate } from "react-router-dom";
import { coachPaths } from "../../routes/coach";
import { useDispatch, useSelector } from "react-redux";
import { fetchCoachList } from "../../redux/features/coach/actions/coachAction";
import Loader from "../../components/loader";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import { fundingPaths } from "../../routes/funding";

const Funding = () => {
  const user = { name: "funding", role: "fund" };
  const { isLoading2, coachList } = useSelector((state) => state.coach.coach);
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const navigate = useNavigate();

  //   const [navBarDemo, setNavBarDemo] = useState("Founder");

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  if (isLoading2) {
    return <Loader />;
  }
  return (
    <MenuLayout user={user}>
      {({ openSignUp }) => (
        <>
          <section class="ct_px_40    pt-5">
            <div class="container-fluid">
              <div class="row align-items-center">
                <div
                  class="col-md-12  mb-4 mb-md-0 "
                  data-aos="fade-down"
                  data-aos-duration="1500"
                >
                  <div class="ct_px_40 ct_px_0_767 text-center">
                    <h2
                      class="ct_fs_50_new mb-4 mx-auto "
                      style={{ maxWidth: "372px" }}
                    >
                      <span className="ct_yellow_text">Fuel</span> Talent.{" "}
                      <span className="ct_yellow_text">Fund</span> the Future.
                    </h2>
                    <p
                      class="mb-0 mt-3 ct_fs_20 mx-auto"
                      style={{ maxWidth: "785px" }}
                    >
                      Whether you're launching a bold idea or seeking projects
                      to support, Nuvio Funding connects innovators with aligned
                      investors — seamlessly and ethically.
                    </p>
                    <div class="ct_mt_30 d-flex align-items-center justify-content-center gap-4 ct_flex_col_575">
                      <a
                        class="ct_yellow_btn ct_outline_yellow_new  px-5 ct_fit_content ct_h_48 ct_w_100_575"
                        onClick={() =>
                          navigate(fundingPaths.FundingSubmitProject)
                        }
                      >
                        Submit Your Project
                      </a>
                      <a
                        class="ct_yellow_btn   px-5 ct_fit_content ct_h_48 ct_w_100_575"
                        onClick={() => navigate(fundingPaths.ExploreProject)}
                      >
                        Explore Project
                      </a>
                    </div>
                  </div>

                  <div className="row ct_mt_30">
                    <div className="col-sm-12">
                      <div className="ct_funding_trusted_main">
                        <img
                          src="../assets/img/become_a_coach_left_img.png"
                          className="ct_img_h_486"
                          style={{ objectPosition: "top" }}
                        />
                        <div className="ct_trsuted_overlay">
                          <p className="text-white ct_mb_16">
                            Trusted by 150,000+ growing businesses
                          </p>
                          <div className="ct_multiimages_users_23">
                            <img src="../assets/img/trusted_1.png" />
                            <img src="../assets/img/trusted_2.png" />
                            <img src="../assets/img/trusted_3.png" />
                            <img src="../assets/img/trusted_4.png" />
                            <img src="../assets/img/trusted_5.png" />
                            <img src="../assets/img/trusted_6.png" />
                            <img src="../assets/img/trusted_7.png" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="ct_pt_130 ct_px_40">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <h4 className="ct_fs_32 text-center ct_darkblue_text ct_mb_60">
                    Choose Your Path
                  </h4>
                </div>
              </div>
              <div className="row">
                <div
                  className="col-xxl-7 col-xl-7 col-lg-7 mb-4 mb-lg-0 "
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <div className="">
                    <h4 className="ct_fs_28 mb-4 ct_darkblue_text ct_text_op_8">
                      Looking for Funding? We’ve Got You.
                    </h4>
                    <p
                      className="ct_fs_20_new  ct_para_scroll ct_custom_scroll"
                      style={{ maxWidth: "579px" }}
                    >
                      Built for startups, creatives, tech, education, and
                      impact-driven ideas Nuvio connects you with{" "}
                      <span className="ct_orange_text">aligned investors</span>{" "}
                      and the support to launch.
                    </p>
                    <ul className="mt-4  ct_para_scroll ct_custom_scroll">
                      <li className="ct_fs_20_new ct_darkblue_text">
                        <span
                          className="ct_dot_10 me-2"
                          style={{ backgroundColor: "#FB8500" }}
                        ></span>{" "}
                        Public project page
                      </li>
                      <li className="mt-2 ct_fs_20_new ct_darkblue_text">
                        <span
                          className="ct_dot_10 me-2"
                          style={{ backgroundColor: "#FB8500" }}
                        ></span>{" "}
                        Visibility in investor network
                      </li>
                      <li className="mt-2 ct_fs_20_new ct_darkblue_text">
                        <span
                          className="ct_dot_10 me-2"
                          style={{ backgroundColor: "#FB8500" }}
                        ></span>{" "}
                        Feedback & coaching
                      </li>
                      <li className="mt-2 ct_fs_20_new ct_darkblue_text">
                        <span
                          className="ct_dot_10 me-2"
                          style={{ backgroundColor: "#FB8500" }}
                        ></span>{" "}
                        Co-investment or grant options
                      </li>
                    </ul>

                    <div className="mt-4">
                      <button
                        className="ct_yellow_btn ct_darkblue_btn"
                        onClick={() =>
                          navigate(fundingPaths.FundingSubmitProject)
                        }
                      >
                        Submit My Project
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  className="col-xxl-5 col-xl-5 col-lg-5  ps-lg-5 mb-4 mb-lg-0"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <div className="ct_choose_img_aspect_991">
                    <img
                      src="../assets/img/choose_path_img_1.png"
                      className="ct_img_h_400"
                    />
                  </div>
                </div>
              </div>
              <div className="row ct_mt_100">
                <div
                  className="col-xxl-6 col-xl-6 col-lg-6 mb-4 mb-lg-0 "
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <div className="ct_minus_mt_40 py-4 ct_choose_img_aspect_991">
                    <img
                      src="../assets/img/choose_path_img_2.png"
                      className="ct_img_h_400"
                    />
                  </div>
                </div>
                <div
                  className="col-xxl-6 col-xl-6 col-lg-6  ps-xl-5 mb-4 mb-lg-0"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <div className="">
                    <h4 className="ct_fs_28 mb-4 ct_darkblue_text ct_text_op_8">
                      Looking to Invest in Bold Ideas?
                    </h4>
                    <p
                      className="ct_fs_20_new  ct_para_scroll ct_custom_scroll"
                      style={{ maxWidth: "579px" }}
                    >
                      Ideal for{" "}
                      <span className="ct_orange_text">investors</span>,
                      corporates, CSR teams, and accelerators discover vetted,
                      purpose-driven projects ready for support and partnership.
                    </p>
                    <ul className="mt-4  ct_para_scroll ct_custom_scroll">
                      <li className="ct_fs_20_new ct_darkblue_text">
                        <span
                          className="ct_dot_10 me-2"
                          style={{ backgroundColor: "#FB8500" }}
                        ></span>{" "}
                        Curated project access
                      </li>
                      <li className="mt-2 ct_fs_20_new ct_darkblue_text">
                        <span
                          className="ct_dot_10 me-2"
                          style={{ backgroundColor: "#FB8500" }}
                        ></span>{" "}
                        Detailed summaries and milestones
                      </li>
                      <li className="mt-2 ct_fs_20_new ct_darkblue_text">
                        <span
                          className="ct_dot_10 me-2"
                          style={{ backgroundColor: "#FB8500" }}
                        ></span>{" "}
                        Contact with project leads
                      </li>
                      <li className="mt-2 ct_fs_20_new ct_darkblue_text">
                        <span
                          className="ct_dot_10 me-2"
                          style={{ backgroundColor: "#FB8500" }}
                        ></span>{" "}
                        Partnership & mentorship opportunities
                      </li>
                    </ul>
                    <div className="mt-4">
                      <button
                        onClick={() => navigate(fundingPaths.ExploreProject)}
                        className="ct_yellow_btn ct_darkblue_btn"
                      >
                        Explore Project
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            data-aos="fade-right"
            data-aos-duration="1500"
            class="ct_looking_for_work_bg      ct_p_111_y_106 ct_mt_100"
            style={{ backgroundColor: "#219EBC" }}
          >
            <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
              <div class="text-white">
                <h4 class="ct_fs_36 mb-4">Where Vision Meets Opportunity</h4>
                <p
                  class="mb-0 ct_fs_18 ct_fw_300"
                  style={{ maxWidth: "680px" }}
                >
                  We don’t just match projects and investors — we build
                  meaningful relationships that fuel progress, innovation, and
                  real-world impact.
                </p>
              </div>
              <div class="ct_flex_shrink_0">
                <a
                  class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                  onClick={openSignUp}
                >
                  Start Your Journey
                </a>
              </div>
            </div>
          </section>

          <section class=" ct_px_40 ct_py_130">
            <div class="container-fluid">
              <div class="row align-items-center">
                <div
                  class="col-lg-4 mb-4 mb-lg-0 aos-init aos-animate"
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <div class="ct_how_work_img">
                    <img
                      src="../assets/img/funding_works_img_left.png"
                      alt=""
                      style={{ objectFit: "cover", objectPosition: "right" }}
                    />
                  </div>
                </div>
                <div
                  class="col-lg-8 mb-4 mb-lg-0 aos-init aos-animate ps-lg-5"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <div class="ct_how_work_content">
                    <h4 class="ct_fs_24_new ct_dakrblue_text">
                      How Funding Works?
                    </h4>
                    <h3 class="ct_fs_32 ct_dakrblue_text ">
                      Connecting founders with aligned investors.
                    </h3>
                  </div>
                  <div class="row mt-5">
                    <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                      <div class="ct_how_work_card">
                        <img
                          src="../assets/img/ri_find-replace-fill_orange.png"
                          alt=""
                          className="ct_w_50_340"
                        />
                        <div class="pt-4">
                          <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                            Share or Discover
                          </h5>
                          <p
                            class="mb-0 ct_fs_16"
                            style={{ maxWidth: "249px" }}
                          >
                            Founders submit their project ideas. Investors
                            explore vetted projects based on category, impact,
                            or stage.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                      <div class="ct_how_work_card">
                        <img
                          src="../assets/img/fa6-solid_handshake_orange.png"
                          alt=""
                          className="ct_w_50_340"
                        />
                        <div class="pt-4">
                          <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                            Match & Connect
                          </h5>
                          <p
                            class="mb-0 ct_fs_16"
                            style={{ maxWidth: "256px" }}
                          >
                            We review, recommend, and facilitate thoughtful
                            introductions that align goals and values.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                      <div class="ct_how_work_card">
                        <img
                          src="../assets/img/uim_bag_orange.png"
                          alt=""
                          className="ct_w_50_340"
                        />
                        <div class="pt-4">
                          <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                            Collaborate and Grow
                          </h5>
                          <p
                            class="mb-0 ct_fs_16"
                            style={{ maxWidth: "256px" }}
                          >
                            Founders receive feedback, funding, and support.
                            Investors build lasting partnerships.st.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="ct_px_40 ">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <h4 className="ct_fs_32 mb-4 ct_darkblue_text text-center">
                    Why Founders and Investors Choose{" "}
                    <span className="ct_orange_text">Nuvio</span>
                  </h4>
                  <p
                    className="ct_fs_20_new ct_darkblue_text mx-auto text-center"
                    style={{ maxWidth: "1108px" }}
                  >
                    Bridging visionary projects and the right support through
                    expert, transparent, and human-centered funding backed by
                    our coaching and talent network to ensure lasting impact..
                  </p>
                </div>
              </div>
              <div className="row ct_mt_60 gx-5">
                <div className="col-md-4 mb-5">
                  <div
                    className="ct_outline_bg ct_winning_team_card_12 d-grid pt-0"
                    style={{ backgroundColor: "hsl(199deg 64% 73% / 40%)" }}
                  >
                    <figure className="mb-0 ct_mt_70 ct_pb_94 ">
                      <div>
                        <img src="../assets/img/direction_orange.png" />
                        <figcaption className="ct_mt_30">
                          <p className="ct_fs_24_new">
                            Deep local expertise combined with an international
                            mindset
                          </p>

                          {/* <div className="ct_winning_team_overlay_content">
                      <ul>
                        <li className="d-flex align-items-start gap-2">
                          <img src="../assets/img/emojione-white-heavy-check-mark-2.svg" />{" "}
                          <span>
                            {" "}
                            Focus on high-value prospects, prioritize top
                            opportunities, and drive meaningful growth.
                          </span>
                        </li>
                        <li className="d-flex align-items-start gap-2 ct_mt_30">
                          <img src="../assets/img/emojione-white-heavy-check-mark-2.svg" />{" "}
                          <span>
                            Automate routine tasks, eliminate bottlenecks, and
                            free up your team to focus on closing deals
                          </span>
                        </li>
                        <li className="d-flex align-items-start gap-2 ct_mt_30">
                          <img src="../assets/img/emojione-white-heavy-check-mark-2.svg" />{" "}
                          <span>
                            {" "}
                            Focus on high-value prospects, prioritize top
                            opportunities, and drive meaningful growth.
                          </span>
                        </li>
                      </ul>
                    </div> */}
                        </figcaption>
                      </div>
                    </figure>
                    <div
                      className="ct_plus_icon_circle ms-auto mt-auto"
                      style={{ backgroundColor: "#FB8500" }}
                    >
                      <i class="fa-solid fa-plus"></i>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 mb-5">
                  <div
                    className="ct_outline_bg ct_winning_team_card_12 pt-0 d-grid"
                    style={{ backgroundColor: "hsl(199deg 64% 73% / 40%)" }}
                  >
                    <figure className="mb-0 ct_mt_70 ct_pb_94">
                      <img src="../assets/img/direction_orange.png" />
                      <figcaption className="ct_mt_30">
                        <p className="ct_fs_24_new">
                          Rigorous, human-focused project vetting for trust and
                          alignment
                        </p>

                        {/* <div className="ct_winning_team_overlay_content">
                      <ul>
                        <li className="d-flex align-items-start gap-2">
                          <img src="../assets/img/emojione-white-heavy-check-mark-2.svg" />{" "}
                          <span>
                            {" "}
                            Equip your team with powerful tools that simplify
                            every stage of the sales journey.
                          </span>
                        </li>
                        <li className="d-flex align-items-start gap-2 ct_mt_30">
                          <img src="../assets/img/emojione-white-heavy-check-mark-2.svg" />{" "}
                          <span>
                            Gain real-time insights to track progress, adjust
                            strategies, and stay ahead of the competition.
                          </span>
                        </li>
                        <li className="d-flex align-items-start gap-2 ct_mt_30">
                          <img src="../assets/img/emojione-white-heavy-check-mark-2.svg" />{" "}
                          <span>
                            {" "}
                            Deliver a seamless experience across teams, ensuring
                            everyone works toward the same goals with clarity
                            and precision.
                          </span>
                        </li>
                      </ul>
                    </div> */}
                      </figcaption>
                    </figure>
                    <div
                      className="ct_plus_icon_circle ms-auto mt-auto"
                      style={{ backgroundColor: "#FB8500" }}
                    >
                      <i class="fa-solid fa-plus"></i>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 mb-5">
                  <div
                    className="ct_outline_bg ct_winning_team_card_12  pt-0 d-grid"
                    style={{ backgroundColor: "hsl(199deg 64% 73% / 40%)" }}
                  >
                    <figure className="ct_mt_70 ct_pb_94">
                      <img src="../assets/img/solid_dark_setting_orange.png" />
                      <figcaption className="ct_mt_30">
                        <p className="ct_fs_24_new">
                          Transparent, ethical funding process integrated with
                          coaching and talent support
                        </p>

                        {/* <div className="ct_winning_team_overlay_content">
                      <ul>
                        <li className="d-flex align-items-start gap-2">
                          <img src="../assets/img/emojione-white-heavy-check-mark-2.svg" />{" "}
                          <span>
                            {" "}
                            Adopt forward-thinking strategies that help your
                            team adapt in a fast-changing market.
                          </span>
                        </li>
                        <li className="d-flex align-items-start gap-2 ct_mt_30">
                          <img src="../assets/img/emojione-white-heavy-check-mark-2.svg" />{" "}
                          <span>
                            Leverage cutting-edge tools and insights to uncover
                            new growth opportunities.
                          </span>
                        </li>
                        <li className="d-flex align-items-start gap-2 ct_mt_30">
                          <img src="../assets/img/emojione-white-heavy-check-mark-2.svg" />{" "}
                          <span>
                            {" "}
                            Continuously evolve your sales approach to outpace
                            competitors and deliver exceptional value.
                          </span>
                        </li>
                      </ul>
                    </div> */}
                      </figcaption>
                    </figure>
                    <div
                      className="ct_plus_icon_circle ms-auto mt-auto "
                      style={{ backgroundColor: "#FB8500" }}
                    >
                      <i class="fa-solid fa-plus"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            data-aos="fade-right"
            data-aos-duration="1500"
            class="ct_looking_for_work_bg ct_looking_for_work_bg_left     ct_p_111_y_106 ct_mt_100"
          >
            <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
              <div class="text-white">
                <h4 class="ct_fs_36 mb-4">Your Google Ads Goes Here</h4>
                <p
                  class="mb-0 ct_fs_18 ct_fw_300"
                  style={{ maxWidth: "680px" }}
                >
                  Get expert coaching to scale smarter and stronger
                </p>
              </div>
              <div class="ct_flex_shrink_0">
                <a
                  class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                  // onClick={() => navigate(coachPaths?.ContactUs)}
                >
                  View Ad
                </a>
              </div>
            </div>
          </section>

          <section
            class="  ct_px_40   ct_mt_130"
            style={{ backgroundColor: "#F5F3EF", paddingBlock: "72px" }}
          >
            <div class="container-fluid">
              <div class="row">
                <div
                  class="col-lg-4 mb-4 mb-lg-0"
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <div class="d-grid h-100 pt-2 pb-5">
                    <h2
                      class="ct_fs_40 ct_darkblue_text"
                      style={{ maxWidth: "300px" }}
                    >
                      Real Stories, real{" "}
                      <span class="ct_yellow_text">success</span>
                    </h2>
                    <div className="ct_arrows mt-auto">
                      <button className="ct_prev ct_arrow_btn" ref={prevRef}>
                        <i class="fa-solid fa-arrow-left"></i>
                      </button>
                      <button className="ct_next ct_arrow_btn" ref={nextRef}>
                        <i class="fa-solid fa-arrow-right"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  class="col-lg-8 mb-4 mb-lg-0"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <Swiper
                    modules={[Navigation, Autoplay]}
                    spaceBetween={20}
                    slidesPerView={1}
                    loop={true}
                    autoplay={{ delay: 2500 }}
                    navigation={{
                      prevEl: prevRef.current,
                      nextEl: nextRef.current,
                    }}
                    onBeforeInit={(swiper) => {
                      swiper.params.navigation.prevEl = prevRef.current;
                      swiper.params.navigation.nextEl = nextRef.current;
                    }}
                    className="ct_real_stories_slider"
                  >
                    {[1, 2, 3, 4, 5]?.map((item, index) => (
                      <SwiperSlide>
                        <div className="ct_story_slide_card">
                          <div className="ct_story_user_img">
                            <img src="../assets/img/fundDashSucc.png" alt="" />
                          </div>
                          <div>
                            <div className="ct_orange_text mb-3">
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                              <i className="fa-solid fa-star"></i>
                            </div>

                            <h3 className="ct_fs_20 ct_darkblue_text mb-3">
                              Built for the Big Stage
                            </h3>

                            <p
                              className="ct_fS_18 ct_darkblue_text"
                              style={{ maxWidth: "402px" }}
                            >
                              Working through NuStar pushed me to deliver my
                              best. The opportunities I seized here propelled me
                              into leading high-profile product launches
                              globally.
                            </p>

                            <div className="mt-5">
                              <h4 className="ct_fs_20 ct_darkblue_text">
                                Oliver Hayes
                              </h4>
                              <p className="ct_fs_18 ct_darkblue_text">
                                Head of Product Innovation at SkyLabs
                              </p>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            </div>
          </section>
          <section
            data-aos="fade-left"
            data-aos-duration="1500"
            class="ct_looking_for_work_bg   ct_mt_100"
            style={{
              paddingTop: "147px",
              paddingBottom: "144px",
              backgroundColor: "#FB8500",
            }}
          >
            <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
              <div class="text-white">
                <h4 class="ct_fs_36 mb-4">From Funding To Growth</h4>
                <p class="mb-0 ct_fs_18 ct_fw_300">
                  Get expert coaching to scale smarter and stronger
                </p>
              </div>
              <div class="ct_flex_shrink_0 ">
                <a
                  class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                  onClick={() => navigate(coachPaths?.WebinarLandingPage)}
                >
                  Explore CoachHub
                </a>
              </div>
            </div>
          </section>

          <section class=" ct_px_40  ct_py_130 pb-0 ">
            <div class="container-fluid">
              <div class="row align-items-center">
                <div
                  class="col-xxl-4  col-xl-5 col-md-6 mb-4 mb-md-0 ps-xl-5 "
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <div class="ct_about_img">
                    <img
                      src="../assets/img/funding_faq_left_img.png"
                      class="ct_img_h_617"
                      alt=""
                    />
                  </div>
                </div>
                <div
                  class="col-xxl-7 col-xl-7 col-md-6 mb-4 mb-md-0 ps-md-5 "
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <div class="ct_about_cnt">
                    <h2 class=" ct_fs_32  ct_mb_60">
                      Frequently asked questions
                    </h2>

                    <div class="ct_faq_question_main ">
                      <div class="accordion" id="faq_accordionExample">
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="faq_one">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapsefaq_one"
                              aria-expanded="false"
                              aria-controls="collapsefaq_one"
                            >
                              How do I get started as a freelancer on NUVIO?
                            </button>
                          </h2>
                          <div
                            id="collapsefaq_one"
                            class="accordion-collapse collapse"
                            aria-labelledby="faq_one"
                            data-bs-parent="#faq_accordionExample"
                          >
                            <div class="accordion-body">
                              <p class="ct_fs_20 mb-3 ct_line_h_30">
                                These costs can spiral but that didn't seem
                                fair. So our prices work differently. Small
                                businesses often need to do similar things: sell
                                online, book appointments, make reservations. So
                                we offer cheaper, pre-packaged Studio Store apps
                                - that solve these brilliantly.
                              </p>
                              <p class="ct_fs_20 mb-0 ct_line_h_30">
                                If you’re doing something new, on a bigger
                                scale, or need more flexibility, then Builder
                                Studio is for you. Prices vary depending on the
                                features you need but again, you’ll know exactly
                                what you’re paying upfront.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="faqtwo">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapsefaq_Two"
                              aria-expanded="true"
                              aria-controls="collapseTwo"
                            >
                              What types of projects can I find on NUVIO?
                            </button>
                          </h2>
                          <div
                            id="collapsefaq_Two"
                            class="accordion-collapse collapse "
                            aria-labelledby="faqtwo"
                            data-bs-parent="#faq_accordionExample"
                          >
                            <div class="accordion-body">
                              <p class="ct_fs_20 mb-3 ct_line_h_30">
                                These costs can spiral but that didn't seem
                                fair. So our prices work differently. Small
                                businesses often need to do similar things: sell
                                online, book appointments, make reservations. So
                                we offer cheaper, pre-packaged Studio Store apps
                                - that solve these brilliantly.
                              </p>
                              <p class="ct_fs_20 mb-0 ct_line_h_30">
                                If you’re doing something new, on a bigger
                                scale, or need more flexibility, then Builder
                                Studio is for you. Prices vary depending on the
                                features you need but again, you’ll know exactly
                                what you’re paying upfront.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="faqthree">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapsefaq_Three"
                              aria-expanded="false"
                              aria-controls="collapsefaq_Three"
                            >
                              How does payment work?
                            </button>
                          </h2>
                          <div
                            id="collapsefaq_Three"
                            class="accordion-collapse collapse"
                            aria-labelledby="faqthree"
                            data-bs-parent="#faq_accordionExample"
                          >
                            <div class="accordion-body">
                              <p class="ct_fs_20 mb-3 ct_line_h_30">
                                These costs can spiral but that didn't seem
                                fair. So our prices work differently. Small
                                businesses often need to do similar things: sell
                                online, book appointments, make reservations. So
                                we offer cheaper, pre-packaged Studio Store apps
                                - that solve these brilliantly.
                              </p>
                              <p class="ct_fs_20 mb-0 ct_line_h_30">
                                If you’re doing something new, on a bigger
                                scale, or need more flexibility, then Builder
                                Studio is for you. Prices vary depending on the
                                features you need but again, you’ll know exactly
                                what you’re paying upfront.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="faqFour">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapsefaq_Four"
                              aria-expanded="false"
                              aria-controls="collapsefaq_Four"
                            >
                              What support does NUVIO provide to freelancers?
                            </button>
                          </h2>
                          <div
                            id="collapsefaq_Four"
                            class="accordion-collapse collapse"
                            aria-labelledby="faqFour"
                            data-bs-parent="#faq_accordionExample"
                          >
                            <div class="accordion-body">
                              <p class="ct_fs_20 mb-3 ct_line_h_30">
                                These costs can spiral but that didn't seem
                                fair. So our prices work differently. Small
                                businesses often need to do similar things: sell
                                online, book appointments, make reservations. So
                                we offer cheaper, pre-packaged Studio Store apps
                                - that solve these brilliantly.
                              </p>
                              <p class="ct_fs_20 mb-0 ct_line_h_30">
                                If you’re doing something new, on a bigger
                                scale, or need more flexibility, then Builder
                                Studio is for you. Prices vary depending on the
                                features you need but again, you’ll know exactly
                                what you’re paying upfront.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div style={{ height: "100px" }}></div>
        </>
      )}
    </MenuLayout>
  );
};

export default Funding;
